import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { installPreloadErrorRecovery } from './routes/lazyWithReload'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

// A modulepreload for a chunk that a deploy removed fails BEFORE any
// import() rejects, so it never reaches the lazy wrapper. Same staleness.
installPreloadErrorRecovery()

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

